/**
 * PDPL / legal consent version SSOT.
 * Bump when terms or privacy policy content changes; stored in users.consent_version on agree.
 */
export const LEGAL_CONSENT_VERSION = '2026-07-10';

/** Display label for legal pages (matches LEGAL_CONSENT_VERSION). */
export const LEGAL_CONSENT_VERSION_LABEL = '2026.07.10';

/**
 * 환불정책은 약관 동의(consent) 흐름에 묶이지 않는 별도 문서라 자체 버전을 둔다.
 * (terms/privacy처럼 users.consent_version에 기록되지 않음 — 그냥 게시용 버전)
 */
export const REFUND_POLICY_VERSION = '2026-08-08';
export const REFUND_POLICY_VERSION_LABEL = '2026.08.08';

/**
 * Build users-row timestamp/version fields when consents are granted (true only).
 * Terms and privacy are recorded separately (no bundled checkbox).
 * @param {{ consentTerms?: boolean, consentPrivacy?: boolean, consentMarketing?: boolean, consentLocation?: boolean }} consents
 * @returns {Record<string, string>}
 */
export function buildConsentTimestampFields(consents = {}) {
  const out = {};
  if (!consents || typeof consents !== 'object') return out;

  const now = new Date().toISOString();
  const version = LEGAL_CONSENT_VERSION;

  if (consents.consentTerms === true) {
    out.terms_agreed_at = now;
    out.consent_version = version;
  }
  if (consents.consentPrivacy === true) {
    out.privacy_agreed_at = now;
    if (!out.consent_version) out.consent_version = version;
  }
  if (consents.consentMarketing === true) {
    out.marketing_agreed_at = now;
    if (!out.consent_version) out.consent_version = version;
  }
  if (consents.consentLocation === true) {
    out.location_agreed_at = now;
    if (!out.consent_version) out.consent_version = version;
  }

  return out;
}
